(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bizkut-look"] && !Shopify.designMode) return;
  try {
    
(function () {
  const selector = '[data-bizkut-look]';
  const instances = new WeakMap();

  function initialize(section) {
    if (instances.has(section)) return;

    const productList = section.querySelector('[data-product-list]');
    const products = Array.from(section.querySelectorAll('[data-product-card]'));
    const hotspots = section.querySelectorAll('[data-product-index]');
    const current = section.querySelector('[data-look-current]');
    const previous = section.querySelector('[data-look-prev]');
    const next = section.querySelector('[data-look-next]');
    if (!productList || !products.length) return;

    const controller = new AbortController();
    const signal = controller.signal;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let scrollTimer = 0;
    let resizeFrame = 0;
    let pendingScrollTarget = null;

    function isScrollable() {
      return productList.scrollWidth > productList.clientWidth + 1;
    }

    function getScrollTarget(product) {
      const listRect = productList.getBoundingClientRect();
      const cardRect = product.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(productList).paddingLeft) || 0;
      const left = productList.scrollLeft + cardRect.left - listRect.left
        - productList.clientLeft - padding;
      return Math.max(0, Math.min(left, productList.scrollWidth - productList.clientWidth));
    }

    function updateProduct(index, shouldScroll, animate = true) {
      if (!Number.isFinite(index)) return;
      activeIndex = (index + products.length) % products.length;

      products.forEach(function (product, i) {
        product.classList.toggle('is-active', i === activeIndex);
        product.classList.toggle('is-highlighted', i === activeIndex);
      });
      hotspots.forEach(function (hotspot) {
        const selected = Number(hotspot.dataset.productIndex) === activeIndex;
        hotspot.classList.toggle('is-active', selected);
        hotspot.setAttribute('aria-pressed', String(selected));
      });
      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');

      // Scroll only this product track, on desktop as well as mobile.
      if (shouldScroll && isScrollable()) {
        pendingScrollTarget = getScrollTarget(products[activeIndex]);
        productList.scrollTo({
          left: pendingScrollTarget,
          behavior: animate && !reducedMotion.matches ? 'smooth' : 'instant'
        });
        queueScrollSync();
      }
    }

    function syncFromScroll() {
      if (!isScrollable()) return;
      // Keep an explicitly selected hotspot active when two cards are visible.
      if (pendingScrollTarget !== null
        && Math.abs(productList.scrollLeft - pendingScrollTarget) < 3) {
        pendingScrollTarget = null;
        return;
      }
      pendingScrollTarget = null;
      let closestIndex = 0;
      let closestDistance = Infinity;
      products.forEach(function (product, i) {
        const distance = Math.abs(getScrollTarget(product) - productList.scrollLeft);
        if (distance < closestDistance - 0.5) {
          closestIndex = i;
          closestDistance = distance;
        }
      });
      updateProduct(closestIndex, false);
    }

    function queueScrollSync() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 160);
    }

    hotspots.forEach(function (hotspot) {
      hotspot.addEventListener('click', function () {
        updateProduct(Number(hotspot.dataset.productIndex), true);
      }, { signal });
    });
    if (previous) previous.addEventListener('click', function () {
      updateProduct(activeIndex - 1, true);
    }, { signal });
    if (next) next.addEventListener('click', function () {
      updateProduct(activeIndex + 1, true);
    }, { signal });

    productList.addEventListener('scroll', queueScrollSync, { passive: true, signal });
    // Native swiping already scrolls the track; do not trigger a second swipe.
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (type) {
      productList.addEventListener(type, function () {
        pendingScrollTarget = null;
      }, { passive: true, signal });
    });
    productList.addEventListener('keydown', function (event) {
      if (event.target !== productList || !isScrollable()) return;
      const indices = {
        ArrowLeft: activeIndex - 1,
        ArrowRight: activeIndex + 1,
        Home: 0,
        End: products.length - 1
      };
      if (!(event.key in indices)) return;
      event.preventDefault();
      updateProduct(indices[event.key], true);
    }, { signal });
    productList.addEventListener('focusin', function (event) {
      const card = event.target.closest('[data-product-card]');
      if (card) updateProduct(Number(card.dataset.productCard), true, false);
    }, { signal });

    function resize() {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(function () {
        pendingScrollTarget = null;
        if (isScrollable()) updateProduct(activeIndex, true, false);
        else productList.scrollTo({ left: 0, behavior: 'instant' });
      });
    }
    window.addEventListener('resize', resize, { signal });
    const resizeObserver = typeof ResizeObserver !== 'undefined'
      ? new ResizeObserver(resize) : null;
    if (resizeObserver) resizeObserver.observe(productList);

    section.addEventListener('shopify:block:select', function (event) {
      const card = event.target.closest('[data-product-card]');
      if (card) updateProduct(Number(card.dataset.productCard), true, false);
    }, { signal });

    instances.set(section, function () {
      controller.abort();
      clearTimeout(scrollTimer);
      cancelAnimationFrame(resizeFrame);
      if (resizeObserver) resizeObserver.disconnect();
      instances.delete(section);
    });
    updateProduct(0, false);
  }

  function forEachSection(root, callback) {
    if (root.matches && root.matches(selector)) callback(root);
    root.querySelectorAll(selector).forEach(callback);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      forEachSection(document, initialize);
    }, { once: true });
  } else {
    forEachSection(document, initialize);
  }

  // Shopify re-renders this section when products are added in the editor.
  // https://shopify.dev/docs/storefronts/themes/best-practices/editor/integrate-sections-and-blocks
  document.addEventListener('shopify:section:load', function (event) {
    forEachSection(event.target, initialize);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    forEachSection(event.target, function (section) {
      const destroy = instances.get(section);
      if (destroy) destroy();
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
